var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9416 3C8.88497 3 4.78472 7.03 4.78472 12H1.73242L5.69023 15.89L5.76146 16.03L9.87188 12H6.81958C6.81958 8.13 10.0041 5 13.9416 5C17.8791 5 21.0636 8.13 21.0636 12C21.0636 15.87 17.8791 19 13.9416 19C11.978 19 10.1975 18.21 8.9155 16.94L7.47074 18.36C9.12916 19.99 11.4082 21 13.9416 21C18.9983 21 23.0985 16.97 23.0985 12C23.0985 7.03 18.9983 3 13.9416 3ZM12.9242 8V13L17.2483 15.52L18.0317 14.24L14.4503 12.15V8H12.9242Z",
    fill: "#323232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.3ffdf61dc365992a7fc3c60e32411dbd.svg";
export { ForwardRef as ReactComponent };